import React from 'react';
import { Table } from 'semantic-ui-react';

const MenuTotalCBGU = React.memo(
  ({
    title = 'Всего:',
    totalCalories,
    totalProteins,
    totalFats,
    totalCarbohydrates,
    isRedHead,
    cbgucalories,
    isCreateTemplate,
  }) => {
    const classNameHeadCell = isRedHead ? 'menu-table-red-head' : '';

    return (
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell className={classNameHeadCell} width="2">
              {title}
            </Table.HeaderCell>
            <Table.HeaderCell className={classNameHeadCell} textAlign="center" width="2">
              K
            </Table.HeaderCell>
            <Table.HeaderCell className={classNameHeadCell} textAlign="center" width="2">
              Б
            </Table.HeaderCell>
            <Table.HeaderCell className={classNameHeadCell} textAlign="center" width="2">
              Ж
            </Table.HeaderCell>
            <Table.HeaderCell className={classNameHeadCell} textAlign="center" width="2">
              У
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row>
            {cbgucalories && !isCreateTemplate ? (
              <Table.Cell textAlign="center">{`Рекомендовано: ${(
                cbgucalories * 0.9
              ).toFixed()}`}</Table.Cell>
            ) : (
              <Table.HeaderCell />
            )}
            <Table.Cell textAlign="center">{totalCalories}</Table.Cell>
            <Table.Cell textAlign="center">{totalProteins}</Table.Cell>
            <Table.Cell textAlign="center">{totalFats}</Table.Cell>
            <Table.Cell textAlign="center">{totalCarbohydrates}</Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  },
);

export default MenuTotalCBGU;



// WEBPACK FOOTER //
// ./src/Components/Common/MenuBlock/MenuTotalCBGU.jsx